export function decodeToken(raw_token: string | undefined): { token: string; userId: string } | null {
  if (!raw_token) {
    return null;
  }

  let tokenParts = [];
  try {
    tokenParts = atob(decodeURIComponent(raw_token)).split(',');
  } catch (e) {
    return null;
  }

  if (tokenParts.length !== 2) {
    // Should be 2 parts: token and userId
    return null;
  }

  // Safe to blindly strip, as no user-input is used in the token
  const token = tokenParts[1].replace('token=', '');
  const userId = tokenParts[0].replace('userId=', '');

  return {
    token,
    userId,
  };
}
